function Footer() {
  return (
    <div>
	<nav className="navbar navbar-expand-lg navbar-light bg-dark footer">
  <span className="navbar-brand"><i className="fa fa-envira text-light"></i></span>
  
    <ul className="navbar-nav mr-auto mt-2 mt-lg-0">
      <span className="text-light">© All Rights reserved by Werardt 2021.</span>
    </ul>
    <form className="form-inline my-2 my-lg-0">
    <i className="fa fa-facebook text-light mx-2"></i>
	<i className="fa fa-instagram text-light mx-2"></i>
	<i className="fa fa-twitter text-light mx-2"></i>
	<i className="fa fa-linkedin text-light mx-2"></i>
    </form>
</nav>
    </div>
  );
}

export default Footer;
